if (!customElements.get('product-tile')) {
  class ProductTile extends HTMLElement {
    constructor() {
      super();
      this.recentlyViewed = [];
    }

    generateBadge = (message) => {
      return `
        <span data-badge class="bg-primaryLight font-semibold border border-badgeGrey text-primaryDark uppercase px-2 py-1 rounded-[4px] text-xxs">
          ${message}
        </span>
      `
    }

    connectedCallback() {
      const productSku = this.dataset.productSku;
      const productHandle = this.dataset.productHandle;
      const inBag = this.dataset.inBag;
      const recent = this.dataset.recent;
      const reviewBucket = document.querySelector('[data-review-bucket]');
      const el = document.createElement('div');
      el.id = `snippet-${Math.round((Math.random() * 100000000))}`;
      el.setAttribute("data-pr-component", "CategorySnippet");

      el.style.visibility = "hidden";
      reviewBucket?.appendChild(el);

      window.pwr = window.pwr || function () {
        (pwr.q = pwr.q || []).push(arguments);
      };

      pwr("render", [{
        api_key: 'b77181c7-76b0-4895-a771-6ed51633e895',
        locale: 'en_US',
        merchant_group_id: '110743687',
        merchant_id: '1830117428',
        page_id: productSku,
        ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
        components: {
          CategorySnippet: el.id
        }
      }]);

      setTimeout(() => {
        this.querySelector('.pr-category-snippet').appendChild(el)
        el.style.visibility = "visible";
      }, 100);
      this.addEventListener('mouseover', (e) => {
        const hoveredEl = e.target.closest('[data-hover-image]');
        const overlay = this.querySelector('[data-hover-overlay]');
        if (!overlay) return;
        
        if (!hoveredEl) {
          overlay.innerHTML = null;
          return;
        }
                
        overlay.innerHTML = `
          <span 
            class="absolute top-0 left-0 w-full h-full bg-cover bg-center rounded-lg mix-blend-multiply"
            style="background-image: url(${hoveredEl.dataset.hoverImage})"
          >
          </span>
        `;
      });
      
      const rating_container = this.querySelector('[data-rating-container]');
      let total = rating_container.querySelector('.pr-category-snippet__total');

      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          total = rating_container.querySelector('.pr-category-snippet__total');

          if (total && (total.innerHTML.toLowerCase().includes('no ratings') || parseInt(total.innerHTML.match(/\d+/)[0], 10) < 5)) {
            rating_container.classList.add('opacity-0', 'h-0');
            rating_container.classList.remove('min-h-6')
            observer.disconnect();
          } else if (!total) {
            rating_container.classList.remove('min-h-6');
          } else {
            rating_container.classList.add('min-h-6')
          }
        });
      });

      observer.observe(rating_container, { childList: true, subtree: true });

      if (total) observer.disconnect();

      // A/B Test for Dynamic Badges that lost. Preserving in the event they want an iteration of it back.
      // if (useDynamicBadge) {
      //   waitForBadgeContainer('[data-badge-container]', (badgeContainer) => {
      //     if (localStorage.getItem('recentlyViewedProducts')) {
      //       this.recentlyViewed = [...new Set([...localStorage.getItem('recentlyViewedProducts')?.split(',')])].slice(0, 5) ?? [];
      //     }

      //     const badge = badgeContainer.querySelector('[data-badge]');
      //     const cartHandles = new Set(window.cart.items.map((item) => item.handle));
      //     const filteredRecentProducts = this.recentlyViewed.filter(
      //       (product) => !cartHandles.has(product)
      //     );

      //     if (cartHandles.has(productHandle)) {
      //       if (badge) {
      //         badge.innerHTML = inBag;
      //       } else {
      //         badgeContainer.insertAdjacentHTML('beforeend', this.generateBadge(inBag))
      //       }
      //     } else if (filteredRecentProducts.length > 0 && filteredRecentProducts.includes(productHandle)) {
      //       if (badge) {
      //         badge.innerHTML = recent;
      //       } else {
      //         badgeContainer.insertAdjacentHTML('beforeend', this.generateBadge(recent))
      //       }
      //     }
      //   });
      // }

      // A/B Test for Percent Off Badges that lost. Preserving in the event they want an iteration of it back.
      // const waitForBadgeContainer = (selector, callback) => {
      //   const observer = new MutationObserver((mutations, observer) => {
      //     const badgeContainer = this.querySelector(selector);
      //     if (badgeContainer) {
      //       callback(badgeContainer);
      //       observer.disconnect();
      //     }
      //   });
      
      //   observer.observe(document.body, { childList: true, subtree: true });
      // }

      // if (typeof showSaleBadge !== 'undefined' && showSaleBadge) {
      //   waitForBadgeContainer('[data-badge-container]', (badgeContainer) => {
      //     const badge = badgeContainer.querySelector('[data-badge]');
      //     const sale_badge = badgeContainer.querySelector('[data-sale-badge]');

      //     if (badge?.innerHTML.toLowerCase().includes('final sale')) badge.style.display = 'none';
      //     if (sale_badge) sale_badge.style.display = 'block';
      //   });
      // } else {
      //   waitForBadgeContainer('[data-badge-container]', (badgeContainer) => {
      //     const badge = badgeContainer.querySelector('[data-badge]');
      //     const sale_badge = badgeContainer.querySelector('[data-sale-badge]');

      //     if (badge?.innerHTML.toLowerCase().includes('final sale')) badge.style.display = 'block';
      //     if (sale_badge) sale_badge.style.display = 'none';
      //   });
      // }
      
    }
  }
  customElements.define('product-tile', ProductTile);
}
